import { render, staticRenderFns } from "./EducationalRatingTable.vue?vue&type=template&id=09dde837&"
import script from "./EducationalRatingTable.vue?vue&type=script&lang=js&"
export * from "./EducationalRatingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports